import { Box, Button, FormControl, Stack, TextField, Select, MenuItem, InputLabel, Paper, ListSubheader, Typography } from "@mui/material";
import { useState, memo, useEffect } from "react";
import { useSignalRContext } from "../../SignalR/useSignalR";
import { useAuth } from "../../provider/authProvider";
import { DateTimePicker } from "@mui/x-date-pickers";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ManualOrderClose from "../../pages/ManualOrderClose";
import { getAllSymbols } from "../../api/symbolApi";

// Prevent scroll wheel from changing numeric input values
const preventScrollOnNumberInputs = () => {
    const handleWheel = (e) => {
        if (e.target.type === 'number' && e.target.closest('.MuiTextField-root')) {
            e.preventDefault();
        }
    };

    // Add event listener to prevent scroll on number inputs
    document.addEventListener('wheel', handleWheel, { passive: false });
    
    // Cleanup function
    return () => {
        document.removeEventListener('wheel', handleWheel);
    };
};

export const Trades2 = memo(() => {
    const {token} = useAuth();
    
    // Prevent scroll wheel from changing numeric input values
    useEffect(() => {
        const cleanup = preventScrollOnNumberInputs();
        return cleanup;
    }, []);
    
    const [symbol, setSymbol] = useState({name: "EURUSD", id: 1, digits: 5});
    const [symbolError, setSymbolError] = useState(false);
    const [volume, setVolume] = useState("1000");
    const [pendingPrice, setPendingPrice] = useState("");
    const [pendingPriceError, setPendingPriceError] = useState("");
    const [volumeError, setVolumeError] = useState(false);
    const [orderType, setOrderType] = useState("Market");
    const [orderTypeError, setOrderTypeError] = useState(false);
    const [expiry, setExpiry] = useState(null);
    const [expiryError, setExpiryError] = useState();
    const [manualCloseOpen, setManualCloseOpen] = useState(false);
    
    // Data recovery on mount
    useEffect(() => {
    }, []);

    const { symbolsList, sendOrderRequest, sendSpreadOrderRequest, sendPing } = useSignalRContext();
    const orderTypesOptions = [
        {label: "Market", value: "1" },
        {label: "Limit", value: "2"},
        {label: "Stop", value: "3"}
    ]
    const orderTypesOptionsII = [
        "Market", "Limit", "Stop"
    ];
    const handleSendOrder = () =>{
    };
    const handleBuy = () =>{                                                                               
        const ClOrderID = Date.now();
        const param= {
            Type: orderType,
            ClOrdId: ClOrderID,
            SymbolId: symbol.id,
            SymbolName: symbol.name,
            lpSymbolName: symbol.lpSymbolName,
            TradeSide: "Buy",
            Quantity: volume,
            TargetPrice: orderType === "Limit" || orderType === "Stop" ?//orderType === "2" || orderType === "3" ?
                            parseFloat( pendingPrice) : 0.00 ,
            Expiry: orderType === "Limit" || orderType === "Stop" ?
                        expiry :  null,
            PositionId: null,
            //Designation: ""
        }
        sendOrderRequest(token, param);
    };
    const handleSell = () =>{
        const ClOrderID = Date.now();
        const param= {
            Type: orderType,
            ClOrdId: ClOrderID,
            SymbolId: symbol.id,
            lpSymbolName: symbol.lpSymbolName,
            SymbolName: symbol.name,
            lpSymbolName: symbol.lpSymbolName,
            TradeSide: "Sell",
            Quantity: volume,
            TargetPrice: orderType === "Limit" || orderType === "Stop" ?//orderType === "2" || orderType === "3" ?
                            parseFloat( pendingPrice) : 0.00 ,
            Expiry: orderType === "Limit" || orderType === "Stop" ?
                        expiry :  null,
            PositionId: null,
            Designation: ""
        }
        sendOrderRequest(token, param);
    };
    return(
        <>
        <Box sx={{
            backgroundColor: 'transparent',
            color: 'white',
            height: '100%',
            padding: "16px",
            marginTop: "5px"
        }}>
           <form onSubmit={handleSendOrder}>
            <Stack 
                justifyContent="center"
                spacing={0.5}
                >
                <h2>Place Order</h2>
                <InputLabel id="Symbol">Symbol</InputLabel>
                <Select
                    label = "Symbol"
                    required
                    variant="outlined"
                    color="primary"
                    type="symbol"
                    size="small"
                    value={symbol}
                    onChange={e=>setSymbol(e.target.value)}
                    error={symbolError}
                >
                    {symbolsList?.map((symbol)=>{
                        return(<MenuItem value={symbol}>{symbol.name}</MenuItem>)
                        
                    })}
                </Select>
                <InputLabel id="Volume">Volume</InputLabel>
                <TextField                    
                    onChange={e=>setVolume(e.target.value)}
                    required
                    variant="outlined"
                    color="secondary"
                    size="small"
                    type="volume"                    
                    value={volume}
                    error={volumeError}
                    margin="normal"
                    />
                <InputLabel id="TargetPrice">Target Price</InputLabel>
                <TextField                    
                    onChange={e=>setPendingPrice(e.target.value)}
                    required
                    variant="outlined"
                    color="secondary"
                    size="small"
                    type="volume"                    
                    value={pendingPrice}
                    error={pendingPriceError}
                    margin="normal"
                    />
                <InputLabel id="oType">OrderType</InputLabel>
                <Select
                    required
                    variant="outlined"
                    color="secondary"
                    size="small"
                    type="orderType"
                    defaultValue={"Market"}

                    //value={orderType}
                    onChange={e=>{return(setOrderType(e.target.value))}}
                    error={orderTypeError}
                    >
                    {orderTypesOptions.map((option)=>{
                        return(<MenuItem value={option.label}>{option.label}</MenuItem>)
                    })}
                </Select>
                <InputLabel id="expiry" >Expiry</InputLabel>
                <DateTimePicker
                    disablePast
                    format="DD/MM/YYYY hh:mm:ss a"
                    views={['day', 'month', 'year', 'hours', 'minutes', 'seconds']}
                    value={expiry}
                    onChange={(newDate)=> setExpiry(newDate)}
                    />
                <Stack direction="row"
                 spacing={2}
                 justifyContent={"center"}
                 >
                    <Button
                        onClick={handleBuy}
                        variant="contained"
                        color="success"
                        >BUY</Button>
                    <Button
                        onClick={handleSell}
                        variant="contained"
                        color="error"
                        >SELL</Button>
                </Stack>
                <Stack direction="row" justifyContent="center" mt={2}>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setManualCloseOpen(true)}
                    >
                        Manual Close Order
                    </Button>
                </Stack>
             </Stack>   
           </form>
        </Box>

        
        {/* Manual Close Modal */}
        <ManualOrderClose 
            open={manualCloseOpen} 
            onClose={() => setManualCloseOpen(false)} 
        />
    </>
    );
});

//Spread Order Component
export const Trades = memo(({ selectedSymbol, selectedAccount }) => {
    const {token} = useAuth();
    
    // Prevent scroll wheel from changing numeric input values
    useEffect(() => {
        const cleanup = preventScrollOnNumberInputs();
        return cleanup;
    }, []);
    
    // Data recovery on mount
    useEffect(() => {
    }, []);
    
    const [symbol1, setSymbol1] = useState({name: "GOLD.AUG25", id: 1, digits: 2});
    const [symbol2, setSymbol2] = useState({name: "XAUUUSD", id: 2, digits: 2});
    const [symbolError, setSymbolError] = useState(false);
    const [symbolError2, setSymbolError2] = useState(false);
    const [volume, setVolume] = useState("1");
    const [volume2, setVolume2] = useState("1");
    const [pendingPrice, setPendingPrice] = useState("");
    const [pendingPrice2, setPendingPrice2] = useState("");
    const [pendingPriceError, setPendingPriceError] = useState("");
    const [pendingPriceError2, setPendingPriceError2] = useState("");
    const [volumeError, setVolumeError] = useState(false);
    const [volumeError2, setVolumeError2] = useState(false);
    const [orderType, setOrderType] = useState("Market");
    const [orderType2, setOrderType2] = useState("Market");
    const [orderTypeError, setOrderTypeError] = useState(false);
    const [orderTypeError2, setOrderTypeError2] = useState(false);
    const [expiry, setExpiry] = useState(null);
    const [expiry2, setExpiry2] = useState(null);
    const [expiryError, setExpiryError] = useState();
    const [expiryError2, setExpiryError2] = useState();
    const [manualCloseOpen, setManualCloseOpen] = useState(false);
    const [symbolsList, setSymbolsList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedSymbol1Data, setSelectedSymbol1Data] = useState(null);
    const [selectedSymbol2Data, setSelectedSymbol2Data] = useState(null);
    const [volume1Validation, setVolume1Validation] = useState({ isValid: true, message: '' });
    const [volume2Validation, setVolume2Validation] = useState({ isValid: true, message: '' });

    const { sendOrderRequest, sendSpreadOrderRequest } = useSignalRContext();
    const orderTypesOptions = [
        {label: "Market", value: "1" },
        {label: "Limit", value: "2"},
        {label: "Stop", value: "3"}
    ]

    // Fetch symbols from API
    useEffect(() => {
        const fetchSymbols = async () => {
            if (!token) return;
            
            setLoading(true);
            try {
                const symbols = await getAllSymbols(token);
                setSymbolsList(symbols);
                const activeSymbols = symbols.filter(symbol => symbol.isActive === true);
            } catch (error) {
                console.error('Error fetching symbols:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchSymbols();
    }, [token]);

    // Handle selected symbol from Market Watch
    useEffect(() => {
        if (selectedSymbol && symbolsList.length > 0) {
            // Find the symbol in our symbols list by name or lpSymbolName
            const foundSymbol = symbolsList.find(s => 
                s.name === selectedSymbol.name || 
                s.lpSymbolName === selectedSymbol.lpSymbolName ||
                s.name === selectedSymbol.lpSymbolName
            );
            
            if (foundSymbol) {
                // Set as Symbol 1 by default
                setSymbol1(foundSymbol);
                setSelectedSymbol1Data(foundSymbol);
                setSymbolError(false);
                setVolumeError(false); // Clear volume error when symbol changes
                setVolume1Validation({ isValid: true, message: '' }); // Clear validation state
                
                // Set initial volume to minLotSize and clear any errors
                if (foundSymbol.minLotSize) {
                    setVolume(foundSymbol.minLotSize.toString());
                }
            }
        }
    }, [selectedSymbol, symbolsList]);

    // Volume validation function for Spread Order
    const validateVolume = (volumeValue, symbolData) => {
        if (!symbolData || !volumeValue) {
            return { isValid: true, message: '' };
        }

        const volumeNum = parseFloat(volumeValue);
        const minLot = parseFloat(symbolData.minLotSize) || 0;
        const maxLot = parseFloat(symbolData.maxLotSize) || Infinity;
        const lotStep = parseFloat(symbolData.lotStep) || 1;

        if (isNaN(volumeNum)) {
            return { isValid: false, message: 'Volume must be a number' };
        }

        if (volumeNum < minLot) {
            return { isValid: false, message: `Volume must be at least ${minLot}` };
        }

        if (volumeNum > maxLot) {
            return { isValid: false, message: `Volume cannot exceed ${maxLot}` };
        }

        // Check if volume is a valid step from minLot
        const stepsFromMin = (volumeNum - minLot) / lotStep;
        if (!Number.isInteger(stepsFromMin)) {
            return { isValid: false, message: `Volume must be in steps of ${lotStep} from ${minLot}` };
        }

        return { isValid: true, message: '' };
    };

    // Handle volume change with validation for Symbol 1
    const handleVolume1Change = (newVolume) => {
        setVolume(newVolume);
        if (selectedSymbol1Data) {
            const validation = validateVolume(newVolume, selectedSymbol1Data);
            setVolume1Validation(validation);
            setVolumeError(!validation.isValid);
        }
    };

    // Handle volume change with validation for Symbol 2
    const handleVolume2Change = (newVolume) => {
        setVolume2(newVolume);
        if (selectedSymbol2Data) {
            const validation = validateVolume(newVolume, selectedSymbol2Data);
            setVolume2Validation(validation);
            setVolumeError2(!validation.isValid);
        }
    };

    // Handle volume increment/decrement with lotStep for Symbol 1
    const handleVolume1Step = (direction) => {
        if (!selectedSymbol1Data) return;
        
        const currentVolume = parseFloat(volume) || 0;
        const lotStep = parseFloat(selectedSymbol1Data.lotStep) || 1;
        const minLot = parseFloat(selectedSymbol1Data.minLotSize) || 0;
        const maxLot = parseFloat(selectedSymbol1Data.maxLotSize) || Infinity;
        
        let newVolume;
        if (direction === 'up') {
            newVolume = currentVolume + lotStep;
            if (newVolume > maxLot) newVolume = maxLot;
        } else {
            newVolume = currentVolume - lotStep;
            if (newVolume < minLot) newVolume = minLot;
        }
        
        handleVolume1Change(newVolume.toString());
    };

    // Handle volume increment/decrement with lotStep for Symbol 2
    const handleVolume2Step = (direction) => {
        if (!selectedSymbol2Data) return;
        
        const currentVolume = parseFloat(volume2) || 0;
        const lotStep = parseFloat(selectedSymbol2Data.lotStep) || 1;
        const minLot = parseFloat(selectedSymbol2Data.minLotSize) || 0;
        const maxLot = parseFloat(selectedSymbol2Data.maxLotSize) || Infinity;
        
        let newVolume;
        if (direction === 'up') {
            newVolume = currentVolume + lotStep;
            if (newVolume > maxLot) newVolume = maxLot;
        } else {
            newVolume = currentVolume - lotStep;
            if (newVolume < minLot) newVolume = minLot;
        }
        
        handleVolume2Change(newVolume.toString());
    };
    
    const handleSendOrder = () =>{
    };
    
    const handleBuy = () =>{                                                                               
        const ClOrderID = Date.now();
        const param= {
            Type: orderType,
            ClOrdId: ClOrderID,
            SymbolId: symbol1.id,
            lpSymbolName: symbol1.lpSymbolName,
            SymbolName: symbol1.name,
            TradeSide: "Buy",
            Quantity: volume,
            TargetPrice: orderType === "Limit" || orderType === "Stop" ?//orderType === "2" || orderType === "3" ?
                            parseFloat( pendingPrice) : 0.00 ,
            Expiry: orderType === "Limit" || orderType === "Stop" ?
                        expiry :  null,
            PositionId: null,
            //Designation: ""
        }
        sendOrderRequest(token, param);
        
        // WORKAROUND: Trigger position refresh after sending order
        setTimeout(() => {
            window.dispatchEvent(new CustomEvent('positionUpdated', { 
                detail: { 
                    orderId: param.ClOrdId,
                    symbol: param.SymbolName,
                    side: param.TradeSide
                } 
            }));
        }, 1000); // Wait 1 second for order to be processed
    };
    
    const handleSell = () =>{
        const ClOrderID = Date.now();
        const param= {
            Type: orderType,
            ClOrdId: ClOrderID,
            SymbolId: symbol1.id,
            lpSymbolName: symbol1.lpSymbolName,
            SymbolName: symbol1.name,
            TradeSide: "Sell",
            Quantity: volume,
            TargetPrice: orderType === "Limit" || orderType === "Stop" ?//orderType === "2" || orderType === "3" ?
                            parseFloat( pendingPrice) : 0.00 ,
            Expiry: orderType === "Limit" || orderType === "Stop" ?
                        expiry :  null,
            PositionId: null,
            Designation: ""
        }
        sendOrderRequest(token, param);
        
        // WORKAROUND: Trigger position refresh after sending order
        setTimeout(() => {
            window.dispatchEvent(new CustomEvent('positionUpdated', { 
                detail: { 
                    orderId: param.ClOrdId,
                    symbol: param.SymbolName,
                    side: param.TradeSide
                } 
            }));
        }, 1000); // Wait 1 second for order to be processed
    };
    
    const handleSpreadBuy = () =>{
        const ClOrderID = Date.now();
        const selectedSymbol1 = symbolsList.find(s => s.id === symbol1.id);
        const selectedSymbol2 = symbolsList.find(s => s.id === symbol2.id);
        
        const param1 = {
            Type: orderType,
            ClOrdId: "1"+ClOrderID,
            SymbolId: symbol1.id,
            SymbolName: selectedSymbol1 ? selectedSymbol1.name : symbol1.name, // Use name field as SymbolName
            lpSymbolName: selectedSymbol1 ? selectedSymbol1.lpSymbolName : symbol1.lpSymbolName, // Add LpSymbolName field
            TradeSide: "Buy",
            Quantity: volume,
            TargetPrice: orderType === "Limit" || orderType === "Stop" ?
                            parseFloat( pendingPrice) : 0.00 ,
            Expiry: orderType === "Limit" || orderType === "Stop" ?
                        expiry :  null,
            PositionId: null,
        }
        const param2 = {
            Type: orderType2,
            ClOrdId: "2"+ClOrderID,
            SymbolId: symbol2.id,
            SymbolName: selectedSymbol2 ? selectedSymbol2.name : symbol2.name, // Use name field as SymbolName
            lpSymbolName: selectedSymbol2 ? selectedSymbol2.lpSymbolName : symbol2.lpSymbolName, // Add LpSymbolName field
            TradeSide: "Sell",
            Quantity: volume2,
            TargetPrice: orderType2 === "Limit" || orderType2 === "Stop" ?
                            parseFloat( pendingPrice2) : 0.00 ,
            Expiry: orderType2 === "Limit" || orderType2 === "Stop" ?
                        expiry2 :  null,
            PositionId: null,
        }
        sendSpreadOrderRequest(token, param1, param2, selectedAccount);
    }

    const handleSpreadSell = () =>{
        const ClOrderID = Date.now();
        const selectedSymbol1 = symbolsList.find(s => s.id === symbol1.id);
        const selectedSymbol2 = symbolsList.find(s => s.id === symbol2.id);
        
        const param1 = {
            Type: orderType,
            ClOrdId: "1"+ClOrderID,
            SymbolId: symbol1.id,
            SymbolName: selectedSymbol1 ? selectedSymbol1.name : symbol1.name, // Use name field as SymbolName
            lpSymbolName: selectedSymbol1 ? selectedSymbol1.lpSymbolName : symbol1.lpSymbolName, // Add LpSymbolName field
            TradeSide: "Sell",
            Quantity: volume,
            TargetPrice: orderType === "Limit" || orderType === "Stop" ?//orderType === "2" || orderType === "3" ?
                            parseFloat( pendingPrice) : 0.00 ,
            Expiry: orderType === "Limit" || orderType === "Stop" ?
                        expiry :  null,
            PositionId: null,
        }   
        const param2 = {
            Type: orderType2,
            ClOrdId: "2"+ClOrderID,
            SymbolId: symbol2.id,
            SymbolName: selectedSymbol2 ? selectedSymbol2.name : symbol2.name, // Use name field as SymbolName
            lpSymbolName: selectedSymbol2 ? selectedSymbol2.lpSymbolName : symbol2.lpSymbolName, // Add LpSymbolName field
            TradeSide: "Buy",
            Quantity: volume2,
            TargetPrice: orderType2 === "Limit" || orderType2 === "Stop" ?//orderType === "2" || orderType === "3" ?
                            parseFloat( pendingPrice2) : 0.00 ,
            Expiry: orderType2 === "Limit" || orderType2 === "Stop" ?
                        expiry2 :  null,
            PositionId: null,
        }
        sendSpreadOrderRequest(token, param1, param2, selectedAccount);
    }

    // Custom menuProps for modern dropdown style
    const menuProps = {
        PaperProps: {
            sx: {
                background: '#232c47',
                borderRadius: '10px',
                color: '#fff',
                boxShadow: 'none',
                mt: 0.5,
                minWidth: 0,
                '& .MuiMenuItem-root': {
                    fontSize: '1.08rem',
                    fontWeight: 500,
                    py: '10px',
                    px: '18px',
                    borderRadius: '6px',
                    '&.Mui-selected': {
                        background: 'rgba(25,195,250,0.08)',
                    },
                    '&:hover': {
                        background: 'rgba(25,195,250,0.15)',
                    },
                },
            },
        },
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        },
    };
    
    return(
        <>
        <Box sx={{
            background: 'none',
            color: 'white',
            height: '100%',
            p: 0,
            m: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
        }}>
            <Box sx={{
                width: '100%',
                maxWidth: 600,
                background: '#181f2c',
                borderRadius: '8px',
                boxShadow: '0 2px 8px 0 rgba(0,0,0,0.12)',
                p: 0,
                m: 0,
            }}>
                <form autoComplete="off">
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6, p: 1, m: 0, pt: 0.5, pb: 0.5 }}>
                        {/* Symbol 1 */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Symbol 1</Typography>
                    <Select
                                labelId="symbol1"
                        id="symbol1_select"
                        required
                        variant="outlined"
                        color="primary"
                        size="small"
                                value={symbol1.id || ''}
                                onChange={e => {
                                    const selectedSymbol = symbolsList.find(s => s.id === e.target.value);
                                    setSymbol1(selectedSymbol || {name: "Select Symbol", id: '', digits: 2});
                                    setSelectedSymbol1Data(selectedSymbol);
                                    setSymbolError(false);
                                    setVolumeError(false); // Clear volume error when symbol changes
                                    setVolume1Validation({ isValid: true, message: '' }); // Clear validation state
                                    
                                    // Set initial volume to minLotSize and clear any errors
                                    if (selectedSymbol && selectedSymbol.minLotSize) {
                                        setVolume(selectedSymbol.minLotSize.toString());
                                    }
                                }}
                        error={symbolError}
                                displayEmpty
                                renderValue={selected => {
                                    const symbol = symbolsList.find(s => s.id === selected);
                                    return symbol ? symbol.name : 'Select Symbol';
                                }}
                                sx={{
                                    background: '#232c47',
                                    borderRadius: '4px',
                                    fontSize: '0.875rem',
                                    fontWeight: 400,
                                    color: '#fff',
                                    height: '32px',
                                }}
                                MenuProps={menuProps}
                            >
                                <MenuItem value="" disabled>Select Symbol</MenuItem>
                                {symbolsList.filter(symbol => symbol.isActive === true).map(symbol => (
                                    <MenuItem value={symbol.id} key={symbol.id}>{symbol.name}</MenuItem>
                                ))}
                    </Select>
                        </FormControl>

                        {/* Symbol 2 */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Symbol 2</Typography>
                    <Select
                                labelId="symbol2"
                                id="symbol2_select"
                        required
                        variant="outlined"
                        color="primary"
                        size="small"
                                value={symbol2.id || ''}
                                onChange={e => {
                                    const selectedSymbol = symbolsList.find(s => s.id === e.target.value);
                                    setSymbol2(selectedSymbol || {name: "Select Symbol", id: '', digits: 2});
                                    setSelectedSymbol2Data(selectedSymbol);
                                    setSymbolError2(false);
                                    // Set initial volume to minLotSize
                                    if (selectedSymbol && selectedSymbol.minLotSize) {
                                        setVolume2(selectedSymbol.minLotSize.toString());
                                    }
                                }}
                        error={symbolError2}
                                displayEmpty
                                renderValue={selected => {
                                    const symbol = symbolsList.find(s => s.id === selected);
                                    return symbol ? symbol.name : 'Select Symbol';
                                }}
                                sx={{
                                    background: '#232c47',
                                    borderRadius: '4px',
                                    fontSize: '0.875rem',
                                    fontWeight: 400,
                                    color: '#fff',
                                    height: '32px',
                                }}
                                MenuProps={menuProps}
                            >
                                <MenuItem value="" disabled>Select Symbol</MenuItem>
                                {symbolsList.filter(symbol => symbol.isActive === true).map(symbol => (
                                    <MenuItem value={symbol.id} key={symbol.id}>{symbol.name}</MenuItem>
                                ))}
                    </Select>
                        </FormControl>

                        {/* Volume 1 */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>
                                Volume 1
                                {selectedSymbol1Data && (
                                    <Typography component="span" sx={{ fontSize: '0.8rem', color: '#7b879d', ml: 1 }}>
                                        (Min: {selectedSymbol1Data.minLotSize}, Max: {selectedSymbol1Data.maxLotSize}, Step: {selectedSymbol1Data.lotStep})
                                    </Typography>
                                )}
                            </Typography>
                            <TextField
                                onChange={e => handleVolume1Change(e.target.value)}
                                required
                                variant="outlined"
                                color="secondary"
                                size="small"
                                type="number"
                                value={volume}
                                error={volumeError}
                                margin="none"
                                placeholder="1"
                                sx={{
                                    background: volumeError ? 'rgba(255, 107, 107, 0.1)' : '#232c47',
                                    borderRadius: '8px',
                                    fontSize: '1.15rem',
                                    fontWeight: 500,
                                    color: volumeError ? '#ff6b6b' : '#fff',
                                    mt: 0,
                                    mb: 0,
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: volumeError ? '#ff6b6b' : 'rgba(6, 182, 212, 0.3)',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: volumeError ? '#ff6b6b' : 'rgba(6, 182, 212, 0.5)',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: volumeError ? '#ff6b6b' : '#1de9b6',
                                        },
                                        '& input[type=number]': {
                                            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                WebkitAppearance: 'none',
                                                margin: 0,
                                            },
                                            MozAppearance: 'textfield',
                                        },
                                    },
                                    '& input[type=number]': {
                                        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                            WebkitAppearance: 'none',
                                            margin: 0,
                                        },
                                        MozAppearance: 'textfield',
                                    },
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <Box sx={{ 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            alignItems: 'center',
                                            mr: 0.5
                                        }}>
                                            <Button
                                                size="small"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleVolume1Step('up');
                                                }}
                                                disabled={!selectedSymbol1Data}
                                                sx={{
                                                    minWidth: '16px',
                                                    width: '16px',
                                                    height: '12px',
                                                    fontSize: '8px',
                                                    background: 'transparent',
                                                    color: '#06b6d4',
                                                    border: 'none',
                                                    padding: 0,
                                                    '&:hover': { 
                                                        background: 'rgba(6, 182, 212, 0.1)',
                                                        color: '#0891b2'
                                                    },
                                                    '&:disabled': { 
                                                        color: '#7b879d',
                                                        background: 'transparent'
                                                    }
                                                }}
                                            >
                                                ▲
                                            </Button>
                                            <Button
                                                size="small"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleVolume1Step('down');
                                                }}
                                                disabled={!selectedSymbol1Data}
                                                sx={{
                                                    minWidth: '16px',
                                                    width: '16px',
                                                    height: '12px',
                                                    fontSize: '8px',
                                                    background: 'transparent',
                                                    color: '#06b6d4',
                                                    border: 'none',
                                                    padding: 0,
                                                    '&:hover': { 
                                                        background: 'rgba(6, 182, 212, 0.1)',
                                                        color: '#0891b2'
                                                    },
                                                    '&:disabled': { 
                                                        color: '#7b879d',
                                                        background: 'transparent'
                                                    }
                                                }}
                                            >
                                                ▼
                                            </Button>
                                        </Box>
                                    )
                                }}
                            />
                            {volume1Validation.message && (
                                <Typography sx={{ fontSize: '0.8rem', color: '#ff6b6b', mt: 0.5 }}>
                                    {volume1Validation.message}
                                </Typography>
                            )}
                        </FormControl>

                        {/* Volume 2 */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Volume 2</Typography>
                <TextField                    
                                onChange={e => { setVolume2(e.target.value); setVolumeError2(false); }}
                    required
                    variant="outlined"
                    color="secondary"
                    size="small"
                                type="number"
                    value={volume2}
                    error={volumeError2}
                                margin="none"
                                placeholder="1"
                                sx={{
                                    background: '#232c47',
                                    borderRadius: '4px',
                                    fontSize: '0.875rem',
                                    fontWeight: 400,
                                    color: '#fff',
                                    height: '32px',
                                    mt: 0,
                                    mb: 0,
                                }}
                            />
                        </FormControl>
                        {/* Order Type 1 */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Order Type 1</Typography>
                <Select
                                labelId="orderType1"
                                id="orderType1_select"
                    required
                    variant="outlined"
                                color="primary"
                    size="small"
                                value={orderType}
                                onChange={e => { setOrderType(e.target.value); setOrderTypeError(false); }}
                    error={orderTypeError}
                                sx={{
                                    background: '#232c47',
                                    borderRadius: '4px',
                                    fontSize: '0.875rem',
                                    fontWeight: 400,
                                    color: '#fff',
                                    height: '32px',
                                }}
                                MenuProps={menuProps}
                            >
                                {orderTypesOptions.map((type) => (
                                    <MenuItem value={type.value} key={type.value}>{type.label}</MenuItem>
                                ))}
                </Select>
                        </FormControl>

                        {/* Order Type 2 */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Order Type 2</Typography>
                <Select
                                labelId="orderType2"
                                id="orderType2_select"
                    required
                    variant="outlined"
                                color="primary"
                    size="small"
                                value={orderType2}
                                onChange={e => { setOrderType2(e.target.value); setOrderTypeError2(false); }}
                    error={orderTypeError2}
                                sx={{
                                    background: '#232c47',
                                    borderRadius: '4px',
                                    fontSize: '0.875rem',
                                    fontWeight: 400,
                                    color: '#fff',
                                    height: '32px',
                                }}
                                MenuProps={menuProps}
                            >
                                {orderTypesOptions.map((type) => (
                                    <MenuItem value={type.value} key={type.value}>{type.label}</MenuItem>
                                ))}
                </Select>
                        </FormControl>

                        {/* Target Price 1 (only for Limit/Stop) */}
                        {(orderType === '2' || orderType === '3') && (
                            <FormControl fullWidth>
                                <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Target Price 1</Typography>
                                <TextField
                                    onChange={e => setPendingPrice(e.target.value)}
                                    variant="outlined"
                                    color="secondary"
                                    size="small"
                                    type="number"
                                    value={pendingPrice}
                                    margin="none"
                                    placeholder="0.00000"
                                    sx={{
                                        background: '#232c47',
                                        borderRadius: '8px',
                                        fontSize: '1.15rem',
                                        fontWeight: 500,
                                        color: '#fff',
                                        mt: 0,
                                        mb: 0,
                                    }}
                                />
                            </FormControl>
                        )}

                        {/* Target Price 2 (only for Limit/Stop) */}
                        {(orderType2 === '2' || orderType2 === '3') && (
                            <FormControl fullWidth>
                                <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Target Price 2</Typography>
                                <TextField
                                    onChange={e => setPendingPrice2(e.target.value)}
                                    variant="outlined"
                                    color="secondary"
                                    size="small"
                                    type="number"
                                    value={pendingPrice2}
                                    margin="none"
                                    placeholder="0.00000"
                                    sx={{
                                        background: '#232c47',
                                        borderRadius: '8px',
                                        fontSize: '1.15rem',
                                        fontWeight: 500,
                                        color: '#fff',
                                        mt: 0,
                                        mb: 0,
                                    }}
                                />
                            </FormControl>
                        )}
                        {/* Expiry 1 (only for Limit/Stop) */}
                        {(orderType === '2' || orderType === '3') && (
                            <FormControl fullWidth>
                                <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Expiry 1</Typography>
                    <DateTimePicker
                        disablePast
                        format="DD/MM/YYYY hh:mm:ss a"
                        views={['day', 'month', 'year', 'hours', 'minutes', 'seconds']}
                        value={expiry}
                                    onChange={newDate => setExpiry(newDate)}
                                    slotProps={{
                                        textField: {
                                            variant: 'outlined',
                                            size: 'small',
                                            sx: {
                                                background: '#232c47',
                                                borderRadius: '8px',
                                                fontSize: '1.15rem',
                                                fontWeight: 500,
                                                color: '#fff',
                                                mt: 0,
                                                mb: 0,
                                            }
                                        }
                                    }}
                                />
                            </FormControl>
                        )}

                        {/* Expiry 2 (only for Limit/Stop) */}
                        {(orderType2 === '2' || orderType2 === '3') && (
                            <FormControl fullWidth>
                                <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Expiry 2</Typography>
                    <DateTimePicker
                        disablePast
                        format="DD/MM/YYYY hh:mm:ss a"
                        views={['day', 'month', 'year', 'hours', 'minutes', 'seconds']}
                        value={expiry2}
                                    onChange={newDate => setExpiry2(newDate)}
                                    slotProps={{
                                        textField: {
                                            variant: 'outlined',
                                            size: 'small',
                                            sx: {
                                                background: '#232c47',
                                                borderRadius: '8px',
                                                fontSize: '1.15rem',
                                                fontWeight: 500,
                                                color: '#fff',
                                                mt: 0,
                                                mb: 0,
                                            }
                                        }
                                    }}
                                />
                            </FormControl>
                        )}

                        {/* Buttons */}
                        <Box sx={{ display: 'flex', gap: 1, mt: 0.5, mb: 0 }}>
                    <Button
                        variant="contained"
                                size="small"
                                sx={{
                                    flex: 1,
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    borderRadius: '4px',
                                    background: '#00e676',
                                    color: '#fff',
                                    boxShadow: 'none',
                                    height: '28px',
                                    minHeight: '28px',
                                    '&:hover': { background: '#00c853' }
                                }}
                                type="button"
                                onClick={handleSpreadBuy}
                            >
                                BUY SPREAD
                            </Button>
                    <Button
                        variant="contained"
                                size="small"
                                sx={{
                                    flex: 1,
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    borderRadius: '4px',
                                    background: '#ff5252',
                                    color: '#fff',
                                    boxShadow: 'none',
                                    height: '28px',
                                    minHeight: '28px',
                                    '&:hover': { background: '#d50000' }
                                }}
                                type="button"
                                onClick={handleSpreadSell}
                            >
                                SELL SPREAD
                            </Button>
                        </Box>

                        {/* Manual Close Button */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 0.5 }}>
                    <Button
                        variant="outlined"
                                size="small"
                                sx={{
                                    fontWeight: 500,
                                    fontSize: '0.75rem',
                                    borderRadius: '4px',
                                    borderColor: '#06b6d4',
                                    color: '#06b6d4',
                                    height: '28px',
                                    minHeight: '28px',
                                    px: 1.5,
                                    '&:hover': {
                                        borderColor: '#0891b2',
                                        color: '#0891b2',
                                        backgroundColor: 'rgba(6, 182, 212, 0.1)'
                                    }
                                }}
                        onClick={() => setManualCloseOpen(true)}
                    >
                        Manual Close Order
                    </Button>
                        </Box>
                    </Box>
           </form>
            </Box>
        </Box>

        
        {/* Manual Close Modal */}
        <ManualOrderClose 
            open={manualCloseOpen} 
            onClose={() => setManualCloseOpen(false)} 
        />
    </>
    );
});

// Quick Order Component
export const QuickOrder = ({ selectedSymbol, selectedAccount }) => {
    const { token } = useAuth();
    const { sendOrderRequest } = useSignalRContext();
    
    
    // Prevent scroll wheel from changing numeric input values
    useEffect(() => {
        const cleanup = preventScrollOnNumberInputs();
        return cleanup;
    }, []);
    const [selectedSymbolId, setSelectedSymbolId] = useState('');
    const [volume, setVolume] = useState('1');
    const [orderType, setOrderType] = useState('1');
    const [stopLoss, setStopLoss] = useState('');
    const [takeProfit, setTakeProfit] = useState('');
    const [targetPrice, setTargetPrice] = useState('');
    const [expiry, setExpiry] = useState(null);
    const [symbolError, setSymbolError] = useState(false);
    const [volumeError, setVolumeError] = useState(false);
    const [orderTypeError, setOrderTypeError] = useState(false);
    const [symbolsList, setSymbolsList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedSymbolData, setSelectedSymbolData] = useState(null);
    const [volumeValidation, setVolumeValidation] = useState({ isValid: true, message: '' });
    const orderTypesOptions = [
        { label: 'Market', value: '1' },
        { label: 'Limit', value: '2' },
        { label: 'Stop', value: '3' }
    ];

    // Fetch symbols from API
    useEffect(() => {
        const fetchSymbols = async () => {
            if (!token) return;
            
            setLoading(true);
            try {
                const symbols = await getAllSymbols(token);
                setSymbolsList(symbols);
                const activeSymbols = symbols.filter(symbol => symbol.isActive === true);
            } catch (error) {
                console.error('Error fetching symbols:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchSymbols();
    }, [token]);

    // Handle selected symbol from Market Watch
    useEffect(() => {
        if (selectedSymbol && symbolsList.length > 0) {
            // Find the symbol in our symbols list by name or lpSymbolName
            const foundSymbol = symbolsList.find(s => 
                s.name === selectedSymbol.name || 
                s.lpSymbolName === selectedSymbol.lpSymbolName ||
                s.name === selectedSymbol.lpSymbolName
            );
            
            if (foundSymbol) {
                setSelectedSymbolId(foundSymbol.id);
                setSelectedSymbolData(foundSymbol);
                setSymbolError(false);
                setVolumeError(false); // Clear volume error when symbol changes
                setVolumeValidation({ isValid: true, message: '' }); // Clear validation state
                
                // Set initial volume to minLotSize and clear any errors
                if (foundSymbol.minLotSize) {
                    setVolume(foundSymbol.minLotSize.toString());
                }
                console.log('Quick Order: Symbol selected from Market Watch:', foundSymbol);
            }
        }
    }, [selectedSymbol, symbolsList]);

    // Volume validation function
    const validateVolume = (volumeValue, symbolData) => {
        if (!symbolData || !volumeValue) {
            return { isValid: true, message: '' };
        }

        const volumeNum = parseFloat(volumeValue);
        const minLot = parseFloat(symbolData.minLotSize) || 0;
        const maxLot = parseFloat(symbolData.maxLotSize) || Infinity;
        const lotStep = parseFloat(symbolData.lotStep) || 1;

        if (isNaN(volumeNum)) {
            return { isValid: false, message: 'Volume must be a number' };
        }

        if (volumeNum < minLot) {
            return { isValid: false, message: `Volume must be at least ${minLot}` };
        }

        if (volumeNum > maxLot) {
            return { isValid: false, message: `Volume cannot exceed ${maxLot}` };
        }

        // Check if volume is a valid step from minLot
        const stepsFromMin = (volumeNum - minLot) / lotStep;
        if (!Number.isInteger(stepsFromMin)) {
            return { isValid: false, message: `Volume must be in steps of ${lotStep} from ${minLot}` };
        }

        return { isValid: true, message: '' };
    };

    // Handle volume change with validation
    const handleVolumeChange = (newVolume) => {
        setVolume(newVolume);
        if (selectedSymbolData) {
            const validation = validateVolume(newVolume, selectedSymbolData);
            setVolumeValidation(validation);
            setVolumeError(!validation.isValid);
        }
    };

    // Handle volume increment/decrement with lotStep
    const handleVolumeStep = (direction) => {
        if (!selectedSymbolData) return;
        
        const currentVolume = parseFloat(volume) || 0;
        const lotStep = parseFloat(selectedSymbolData.lotStep) || 1;
        const minLot = parseFloat(selectedSymbolData.minLotSize) || 0;
        const maxLot = parseFloat(selectedSymbolData.maxLotSize) || Infinity;
        
        let newVolume;
        if (direction === 'up') {
            newVolume = currentVolume + lotStep;
            if (newVolume > maxLot) newVolume = maxLot;
        } else {
            newVolume = currentVolume - lotStep;
            if (newVolume < minLot) newVolume = minLot;
        }
        
        handleVolumeChange(newVolume.toString());
    };

    // Custom menuProps for modern dropdown style
    const menuProps = {
      PaperProps: {
        sx: {
          background: '#232c47',
          borderRadius: '10px',
          color: '#fff',
          boxShadow: 'none',
          mt: 0.5,
          minWidth: 0, // allow it to match input width
          '& .MuiMenuItem-root': {
            fontSize: '1.08rem',
            fontWeight: 500,
            py: '10px',
            px: '18px',
            borderRadius: '6px',
            '&.Mui-selected': {
              background: 'rgba(25,195,250,0.08)',
            },
            '&:hover': {
              background: 'rgba(25,195,250,0.15)',
            },
          },
        },
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
      },
      // Remove getContentAnchorEl for MUI v5+
    };
    const handleSendQuickOrder = (side) => (e) => {
        e.preventDefault();
        const selectedSymbol = symbolsList.find(s => s.id === selectedSymbolId);
        if (!selectedSymbol) { 
            console.error('Quick Order: No symbol selected');
            setSymbolError(true); 
            return; 
        }
        if (!volume) { 
            console.error('Quick Order: No volume specified');
            setVolumeError(true); 
            return; 
        }
        if (!orderType) { 
            console.error('Quick Order: No order type specified');
            setOrderTypeError(true); 
            return; 
        }
        
        console.log('Quick Order: Selected symbol:', selectedSymbol);
        console.log('Quick Order: lpSymbolName:', selectedSymbol.lpSymbolName);
        
        const param = {
            Type: orderType,
            ClOrdId: Date.now(),
            SymbolId: selectedSymbol.id,
            SymbolName: selectedSymbol.name, // Use name field as SymbolName
            lpSymbolName: selectedSymbol.lpSymbolName || selectedSymbol.name, // Add LpSymbolName field with fallback
            TradeSide: side, // 'Buy' or 'Sell'
            Quantity: volume,
            TargetPrice: (orderType === '2' || orderType === '3') ? parseFloat(targetPrice) : 0.00,
            Expiry: (orderType === '2' || orderType === '3') ? expiry : null,
            PositionId: null,
            Designation: "",
            AccountNumber: selectedAccount
        };
        console.log('Quick Order param (with AccountNumber):', param);

        if (typeof sendOrderRequest === 'function') {
            sendOrderRequest(token, param, selectedAccount);
            
            // WORKAROUND: Trigger position refresh after sending order
            console.log('Quick Order: Order sent, triggering position refresh');
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('positionUpdated', { 
                    detail: { 
                        orderId: param.ClOrdId,
                        symbol: param.SymbolName,
                        side: param.TradeSide
                    } 
                }));
            }, 1000); // Wait 1 second for order to be processed
            
        } else {
            console.error('Quick Order: sendOrderRequest is not a function:', typeof sendOrderRequest);
            toast.error('Order function not available');
        }
    };
    return (
        <Box sx={{
            background: 'none',
            color: 'white',
            height: '100%',
            p: 0,
            m: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
        }}>
            <Box sx={{
                width: '100%',
                maxWidth: 600,
                background: '#181f2c',
                borderRadius: '8px',
                boxShadow: '0 2px 8px 0 rgba(0,0,0,0.12)',
                p: 0,
                m: 0,
            }}>
                <form autoComplete="off">
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6, p: 1, m: 0, pt: 0.5, pb: 0.5 }}>
                        {/* Symbol */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Symbol</Typography>
                            <Select
                                labelId="symbol"
                                id="symbol_select"
                                required
                                variant="outlined"
                                color="primary"
                                size="small"
                                value={selectedSymbolId}
                                onChange={e => { 
                                    const selectedSymbol = symbolsList.find(s => s.id === e.target.value);
                                    setSelectedSymbolId(e.target.value); 
                                    setSelectedSymbolData(selectedSymbol);
                                    setSymbolError(false);
                                    setVolumeError(false); // Clear volume error when symbol changes
                                    setVolumeValidation({ isValid: true, message: '' }); // Clear validation state
                                    
                                    // Set initial volume to minLotSize and clear any errors
                                    if (selectedSymbol && selectedSymbol.minLotSize) {
                                        setVolume(selectedSymbol.minLotSize.toString());
                                    }
                                }}
                                error={symbolError}
                                displayEmpty
                                renderValue={selected => {
                                    const symbol = symbolsList.find(s => s.id === selected);
                                    return symbol ? symbol.name : 'Select Symbol';
                                }}
                                sx={{
                                    background: '#232c47',
                                    borderRadius: '4px',
                                    fontSize: '0.875rem',
                                    fontWeight: 400,
                                    color: '#fff',
                                    height: '32px',
                                }}
                                MenuProps={menuProps}
                            >
                                <MenuItem value="" disabled>Select Symbol</MenuItem>
                                {symbolsList.filter(symbol => symbol.isActive === true).map(symbol => (
                                    <MenuItem value={symbol.id} key={symbol.id}>{symbol.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {/* Volume */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>
                                Volume
                                {selectedSymbolData && (
                                    <Typography component="span" sx={{ fontSize: '0.8rem', color: '#7b879d', ml: 1 }}>
                                        (Min: {selectedSymbolData.minLotSize}, Max: {selectedSymbolData.maxLotSize}, Step: {selectedSymbolData.lotStep})
                                    </Typography>
                                )}
                            </Typography>
                            <TextField
                                onChange={e => handleVolumeChange(e.target.value)}
                                required
                                variant="outlined"
                                color="secondary"
                                size="small"
                                type="number"
                                value={volume}
                                error={volumeError}
                                margin="none"
                                placeholder="1"
                                sx={{
                                    background: volumeError ? 'rgba(255, 107, 107, 0.1)' : '#232c47',
                                    borderRadius: '8px',
                                    fontSize: '1.15rem',
                                    fontWeight: 500,
                                    color: volumeError ? '#ff6b6b' : '#fff',
                                    mt: 0,
                                    mb: 0,
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: volumeError ? '#ff6b6b' : 'rgba(6, 182, 212, 0.3)',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: volumeError ? '#ff6b6b' : 'rgba(6, 182, 212, 0.5)',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: volumeError ? '#ff6b6b' : '#1de9b6',
                                        },
                                        '& input[type=number]': {
                                            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                WebkitAppearance: 'none',
                                                margin: 0,
                                            },
                                            MozAppearance: 'textfield',
                                        },
                                    },
                                    '& input[type=number]': {
                                        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                            WebkitAppearance: 'none',
                                            margin: 0,
                                        },
                                        MozAppearance: 'textfield',
                                    },
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <Box sx={{ 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            alignItems: 'center',
                                            mr: 0.5
                                        }}>
                                            <Button
                                                size="small"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleVolumeStep('up');
                                                }}
                                                disabled={!selectedSymbolData}
                                                sx={{
                                                    minWidth: '16px',
                                                    width: '16px',
                                                    height: '12px',
                                                    fontSize: '8px',
                                                    background: 'transparent',
                                                    color: '#06b6d4',
                                                    border: 'none',
                                                    padding: 0,
                                                    '&:hover': { 
                                                        background: 'rgba(6, 182, 212, 0.1)',
                                                        color: '#0891b2'
                                                    },
                                                    '&:disabled': { 
                                                        color: '#7b879d',
                                                        background: 'transparent'
                                                    }
                                                }}
                                            >
                                                ▲
                                            </Button>
                                            <Button
                                                size="small"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleVolumeStep('down');
                                                }}
                                                disabled={!selectedSymbolData}
                                                sx={{
                                                    minWidth: '16px',
                                                    width: '16px',
                                                    height: '12px',
                                                    fontSize: '8px',
                                                    background: 'transparent',
                                                    color: '#06b6d4',
                                                    border: 'none',
                                                    padding: 0,
                                                    '&:hover': { 
                                                        background: 'rgba(6, 182, 212, 0.1)',
                                                        color: '#0891b2'
                                                    },
                                                    '&:disabled': { 
                                                        color: '#7b879d',
                                                        background: 'transparent'
                                                    }
                                                }}
                                            >
                                                ▼
                                            </Button>
                                        </Box>
                                    )
                                }}
                            />
                            {volumeValidation.message && (
                                <Typography sx={{ fontSize: '0.8rem', color: '#ff6b6b', mt: 0.5 }}>
                                    {volumeValidation.message}
                                </Typography>
                            )}
                        </FormControl>
                        {/* Order Type */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Order Type</Typography>
                            <Select
                                labelId="orderType"
                                id="orderType_select"
                                required
                                variant="outlined"
                                color="primary"
                                size="small"
                                value={orderType}
                                onChange={e => { setOrderType(e.target.value); setOrderTypeError(false); }}
                                error={orderTypeError}
                                sx={{
                                    background: '#232c47',
                                    borderRadius: '4px',
                                    fontSize: '0.875rem',
                                    fontWeight: 400,
                                    color: '#fff',
                                    height: '32px',
                                }}
                                MenuProps={menuProps}
                            >
                                {orderTypesOptions.map((type) => (
                                    <MenuItem value={type.value} key={type.value}>{type.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {/* Target Price (only for Limit/Stop) */}
                        {(orderType === '2' || orderType === '3') && (
                            <FormControl fullWidth>
                                <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Target Price</Typography>
                                <TextField
                                    onChange={e => setTargetPrice(e.target.value)}
                                    variant="outlined"
                                    color="secondary"
                                    size="small"
                                    type="number"
                                    value={targetPrice}
                                    margin="none"
                                    placeholder="0.00000"
                                    sx={{
                                        background: '#232c47',
                                        borderRadius: '8px',
                                        fontSize: '1.15rem',
                                        fontWeight: 500,
                                        color: '#fff',
                                        mt: 0,
                                        mb: 0,
                                    }}
                                />
                            </FormControl>
                        )}
                        {/* Expiry (only for Limit/Stop) */}
                        {(orderType === '2' || orderType === '3') && (
                            <FormControl fullWidth>
                                <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Expiry</Typography>
                                <DateTimePicker
                                    disablePast
                                    format="DD/MM/YYYY hh:mm:ss a"
                                    views={['day', 'month', 'year', 'hours', 'minutes', 'seconds']}
                                    value={expiry}
                                    onChange={newDate => setExpiry(newDate)}
                                    slotProps={{
                                        textField: {
                                            variant: 'outlined',
                                            size: 'small',
                                            sx: {
                                                background: '#232c47',
                                                borderRadius: '8px',
                                                fontSize: '1.15rem',
                                                fontWeight: 500,
                                                color: '#fff',
                                                mt: 0,
                                                mb: 0,
                                            }
                                        }
                                    }}
                                />
                            </FormControl>
                        )}
                        {/* Stop Loss */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Stop Loss</Typography>
                            <TextField
                                onChange={e => setStopLoss(e.target.value)}
                                variant="outlined"
                                color="secondary"
                                size="small"
                                type="number"
                                value={stopLoss}
                                margin="none"
                                placeholder="0.00000"
                                sx={{
                                    background: '#232c47',
                                    borderRadius: '4px',
                                    fontSize: '0.875rem',
                                    fontWeight: 400,
                                    color: '#fff',
                                    height: '32px',
                                    mt: 0,
                                    mb: 0,
                                }}
                            />
                        </FormControl>
                        {/* Take Profit */}
                        <FormControl fullWidth>
                            <Typography sx={{ mb: 0.3, fontWeight: 500, fontSize: '0.75rem', color: '#bfc9db' }}>Take Profit</Typography>
                            <TextField
                                onChange={e => setTakeProfit(e.target.value)}
                                variant="outlined"
                                color="secondary"
                                size="small"
                                type="number"
                                value={takeProfit}
                                margin="none"
                                placeholder="0.00000"
                                sx={{
                                    background: '#232c47',
                                    borderRadius: '4px',
                                    fontSize: '0.875rem',
                                    fontWeight: 400,
                                    color: '#fff',
                                    height: '32px',
                                    mt: 0,
                                    mb: 0,
                                }}
                            />
                        </FormControl>
                        {/* Buttons */}
                        <Box sx={{ display: 'flex', gap: 1, mt: 0.5, mb: 0 }}>
                            <Button
                                variant="contained"
                                size="small"
                                disabled={!volumeValidation.isValid || !selectedSymbolData}
                                sx={{
                                    flex: 1,
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    borderRadius: '4px',
                                    background: !volumeValidation.isValid || !selectedSymbolData ? '#7b879d' : '#00e676',
                                    color: '#fff',
                                    boxShadow: 'none',
                                    height: '28px',
                                    minHeight: '28px',
                                    '&:hover': {
                                        background: !volumeValidation.isValid || !selectedSymbolData ? '#7b879d' : '#00c853'
                                    }
                                }}
                                type="button"
                                onClick={handleSendQuickOrder('Buy')}
                            >
                                BUY
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                disabled={!volumeValidation.isValid || !selectedSymbolData}
                                sx={{
                                    flex: 1,
                                    fontWeight: 600,
                                    fontSize: '0.75rem',
                                    borderRadius: '4px',
                                    background: !volumeValidation.isValid || !selectedSymbolData ? '#7b879d' : '#ff5252',
                                    color: '#fff',
                                    boxShadow: 'none',
                                    height: '28px',
                                    minHeight: '28px',
                                    '&:hover': {
                                        background: !volumeValidation.isValid || !selectedSymbolData ? '#7b879d' : '#d50000'
                                    }
                                }}
                                type="button"
                                onClick={handleSendQuickOrder('Sell')}
                            >
                                SELL
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Box>
        </Box>
    );
};